<template>
    <div class="body-all-container HearingTest-greeting--header" >
        <h1 class="text-xs-center">{{ start_exam }}</h1>
        <v-layout row wrap >
            <v-flex sm6 xs12>
                <div class="HearingTest-greeting--left ">
                    <div class="HearingTest-greeting--subHeader ng-binding">آیا فکر میکنید که کم شنوایی دارید؟</div>
                    <div class="HearingTest-greeting--content ng-binding">تست شنوایی آنلاین ما را انجام دهید یا به یک متخصص شنوایی برای ارزیابی کامل شنوایی در شهر خودتان مراجعه کنید.</div>
                    <div class="HearingTest-greeting--reminder ng-binding">این تست باید در کمتر از 5دقیقه انجام شود.</div>
                </div>
            </v-flex>
            <v-flex sm6 xs12>
                <div class="HearingTest-greeting--loadingBar">
                    <router-link id="start_exam_btn" class="btn btn-primary" to="/hearing-questions">{{ start_btn }}</router-link>
                </div>
            </v-flex>
        </v-layout>
            <div class="HearingTest-greeting--description">
                <v-layout row wrap>
                    <v-flex  sm6 xs12>
                        <v-layout row wrap>
                            <v-flex sm6 xs12>
                                <div class="description-content-left ng-binding">تست شنوایی آنلاین نمیتواند جایگزین یک ارزیابی کامل توسط متخصص شنوایی شناسی باشد اما به بررسی هرگونه کم شنوایی که در حال حاضر دارید کمک میکند.</div>
                            </v-flex>
                            <v-flex sm6 xs12 hidden-xs-only>
                                <div class="description-image-wrap">
                                    <img src="./../assets/images/hearingtest-screenshot-en-us.png">
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-flex>

                    <v-flex  sm6 xs12>
                        <div class="description-content-right ng-binding">به محض اتمام آزمون، نتایج تست شنوایی بعلاوه پیشنهاداتی برای مراحل بعدی به شما داده خواهد شد.</div>
                    </v-flex>
                </v-layout>
            </div>
        <v-layout row wrap justify-center align-center>
            <v-flex sm11 xs12 px-4>
                <h2 >سوالات رایج در مورد تست شنوایی:</h2>
                <v-expansion-panel>
                    <v-expansion-panel-content v-for="item in faq_items" :key="item.id">
                        <div slot="header">{{ item.question }}</div>
                        <v-card>
                            <v-card-text class="grey lighten-3" v-html="item.answer"></v-card-text>
                        </v-card>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-flex>
        </v-layout>
    </div>

</template>

<script>
    import test from '@/assets/sounds/calibration/continuousDiscourse_RL.mp3';
export default {
    name: 'IndexPage',
    data () {
        return {
          start_exam: 'هم اکنون شنوایی خود را تست کنید!',
            start_btn: 'شروع تست',
            faq_items:[
                {
                    id:1,
                    question: 'تفاوت بین تست شنوایی آنلاین پرشیاتون و ارزیابی شنوایی در مطب چیست؟',
                    answer:'<p>تست شنوایی آنلاین، چگونگی تاثیر کم شنوایی بر زندگی شما را نشان میدهد، مثلا با مرور بر جنبه های مهم شنوایی و ارتباطات، تاثیر کم شنوایی بر روابط اجتماعی فرد را مشخص میکند.</p>\n' +
                    '<p>ارزیابی و چکاب شنوایی در مطب، یک آنالیز کامل از میزان شنوایی و تاثیر آن بر ارتباطات اجتماعی شما را ارائه میدهد، این ارزیابی میتواند راه حلی برای بهبود شنوایی و زندگی تان فراهم کند.</p>'
                },
                {
                    id:1,
                    question: 'چگونه میتوانم دقیق ترین نتایج را حین انجام تست شنوایی آنلاین پرشیاتون بدست آورم؟',
                    answer:'<p>به یک محیط آرام بروید، از هدفون استفاده کنید و تمرکز کنید، عجله نکنید و نگران نباشید، تست شنوایی آنلاین فرصتی برای بهبود موقعیت شخصی شماست.</p>'
                },
                {
                    id:1,
                    question: 'چگونه هر قسمت از نتایج تست شنوایی آنلاین پرشیاتون را تفسیر کنم؟هر قسمت چه معنی دارد؟',
                    answer: '<p>تست شنوایی آنلاین به معنای جایگزینی برای یک ارزیابی کامل شنوایی توسط یک متخصص شنوایی نیست اما میتواند به شناسایی هرگونه مشکل شنوایی بالقوه که شما دارید کمک نماید.</p>\n' +
                    '<p style="margin-right: 15px;">سوالات تجربی</p>\n' +
                    '<p style="margin-right: 30px;">تجربه شخصی شما یکی از قوی ترین نشانه های وجود کم شنوایی بالقوه میباشد.</p>\n' +
                    '<p style="margin-right: 15px;">نتایج تون خالص</p>\n' +
                    '<p style="margin-right: 30px;">این یک تست مرسوم برای فهمیدن میزان حساسیت شما به صداهای مختلف میباشد.</p>\n' +
                    '<p style="margin-right: 15px;">نتایج تست گفتاری</p>\n' +
                    '<p style="margin-right: 30px;">نتایج این تست چگونگی کار کردن گوش و مغز باهم برای فهمیدن ارتباط شما با دیگران را نشان میدهد.</p>'
                },
                {
                    id:1,
                    question: 'وقتی یکبار تست شنوایی آنلاین پرشیاتون را کامل کردم، در مرحله بعد چه کاری باید انجام دهم؟',
                    answer:'<p>بر اساس نتایج شخصی شما پس از تکمیل تست، ما پیشنهادات ویژه ای را برای مراحل بعدیتان به شما ارائه خواهیم کرد.</p>'
                },
                {
                    id:1,
                    question: 'یک ارزیابی شنوایی حرفه ای شامل چه مواردی میباشد؟',
                    answer:'<p>\n' +
                    '                            معاینه و دیدن گوش: با استفاده از اتوسکوپ، یک معاینه حرفه ای میتواند کانال گوش را از نظر نشانه هایی مانند انسداد و دیگر ابنورمالیتی ها بررسی کند.\n' +
                    '                            <br>\n' +
                    '                            تست تون خالص: این تست کمترین صداهایی که یک شخص با فرکانس هایی از پایین به بالا میتواند بشنود را معین میکند.\n' +
                    '                            <br>\n' +
                    '                            تست گفتاری: در اینجا از شما خواسته میشود که کلمات گفته شده مختلفی را در سطوح متفاوت بشنوید، تشخیص دهید و تکرار کنید.\n' +
                    '                            <br>\n' +
                    '                            تست گفتار در نویز: از شما خواسته میشود کلماتی که در محیط نویزی(پرسر و صدا) گفته میشوند را تکرار کنید.\n' +
                    '                            <br>\n' +
                    '                            تست های تعیین عملکرد گوش میانی: در طی این تست، متخصص مقادیر مختلفی از فشار هوا را در کانال گوش، برای ارزیابی وضعیت گوش میانی و پرده گوش مورد استفاده قرار میدهد.\n' +
                    '                            <br>\n' +
                    '                            تست گسیل های صوتی(OAE): این تست اطلاعاتی را در مورد عملکرد سلول های مویی خارجی فراهم میکند.\n' +
                    '                            <br>\n' +
                    '                            تاریخچه گیری: سوال کردن در مورد تاریخچه شخصی شما شامل: تاریخچه پزشکی، داروهای مصرفی، تاریخچه خانوادگی و وضعیت شنوایی شما، به متخصص شنوایی اجاره میدهد که نیاز های اصلی شما را بهتر شناسایی کند.\n' +
                    '                            <br>\n' +
                    '                            ارزیابی نیازهای ارتباطی: ارزیابی نیازهای شنوایی و ارتباطی شما برای تعیین وسیله تقویتی مناسبی که ممکن است نیاز داشته باشید.\n' +
                    '                            <br>\n' +
                    '                            ارزیابی پیشرفت با وسایل کمک شنوایی: متخصص چگونگی کارکرد شما با وسیله کمک شنوایی جدیدتان را برای تعیین اینکه آیا نیاز به تغییراتی دارد یا نه، بررسی میکند.\n' +
                    '                            <br>\n' +
                    '                        </p>'
                },
                {
                    id:1,
                    question: 'هرچند وقت یکبار باید تست های شنوایی را انجام دهم؟',
                    answer:'<p>تست های آنلاین همیشه در دسترس اند، اما انجمن پرشکی آمریکا پیشنهاد میکند چکاب شنوایی را هر 3 سال یکبار انجام دهید.</p>'
                }
            ],
        }
    }
}
</script>
<style scoped>
    .HearingTest-greeting--header h1 {
        padding: 12px 0 8px;
        background-color: #00b7c6;
        font-weight: normal;
        font-style: normal;
        font-size: 28px;
        line-height: 48px;
        color: #fff;
        text-align: center;
    }
    .HearingTest-greeting--loadingBar {
        margin: 36px 0 0;
    }
    .HearingTest-greeting--left .HearingTest-greeting--subHeader {
        padding: 36px 10% 0;
        font-weight: bold;
        font-style: normal;
        font-size: 28px;
        line-height: 36px;
        color: #00b7c6;
    }
    .HearingTest-greeting--left .HearingTest-greeting--content {
        padding: 16px 10% 0;
        font-weight: normal;
        font-style: normal;
        font-size: 16px;
        line-height: 22px;
        color: #000;
    }
    .HearingTest-greeting--left .HearingTest-greeting--reminder {
        padding: 20px 10%;
        font-weight: normal;
        font-style: normal;
        font-size: 16px;
        line-height: 22px;
        color: #000;
    }
    .HearingTest-greeting--description {
        margin-top: 25px;
        background: rgba(255, 255, 255, 0.8) url(./../assets/images/person-taking-test.png) 10% 132% no-repeat;
        clear: both;
        display: block;
        height: auto;
        padding: 15px 5% 50px;
    }
    .HearingTest-greeting--description .description-content-left {

        padding-left: 5%;
        border-bottom: 0 none;
        padding: 0;
    }
    .description-image-wrap {
        display: block;

    }
    .description-image-wrap img {
        width: 100%;
        padding: 0 10%;
        border-left: 1px solid #ccc;
    }
    .HearingTest-greeting--description .description-content-right {
        width: 70%;
        padding-top: 0;
        padding-right: 15px;
    }

    @media (max-width: 599px) {
        .HearingTest-greeting--loadingBar{
            background: none;
            background-size: contain;
            padding: 0;
            margin: 10px 0 0;
        }
        .HearingTest-greeting--description{
            background: none;
        }
        .HearingTest-greeting--description .description-content-left {
            padding: 15px 0;
            border-bottom: 1px dotted #ccc;
        }
        .HearingTest-greeting--description .description-content-right {
            width: 100%;
            padding: 15px 0;
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/Index.vue